import { deleteCookie, getCookie } from "modules/app/utlis/cookies";
import { useCreateCustomerAndSubscriptionByAppsumo } from "modules/appsumo/hooks/useCreateCustomerAndSubscriptionByAppsumo";
import {
  selectIsAnonymousUser,
  selectUser,
} from "modules/auth/redux/selectors";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { PageLoader } from "@remo-co/ui-core/src/components/PageLoader";
import { useI18n } from "i18n";
import userProfileApi from "modules/userProfile/userProfile.api";
import useAuth from "modules/auth/hooks/useAuth";
import useNotificationActions from "modules/notification/hooks/useNotificationActions";
import { Appsumo } from "./constants";

export const ManageAppsumoSubscription = (): JSX.Element | null => {
  const [isSubscriptionStarted, setIsSubscriptionStarted] = useState(false);
  const user = useSelector(selectUser);
  const { signOut } = useAuth();
  const isUserAnonymous = useSelector(selectIsAnonymousUser);
  const appsumoLicenseKey = getCookie(Appsumo.licenseKey);
  const { t } = useI18n(["common"]);
  const { createCustomerAndSubscriptionByAppsumo } =
    useCreateCustomerAndSubscriptionByAppsumo();
  const { addErrorNotification } = useNotificationActions();

  useEffect(() => {
    if (!appsumoLicenseKey) {
      return;
    }

    if (isUserAnonymous) {
      signOut();

      return;
    }

    const call = async () => {
      setIsSubscriptionStarted(true);
      const resp = await userProfileApi.updateMyProfile({ appsumoLicenseKey });
      if (resp.isSuccess) {
        createCustomerAndSubscriptionByAppsumo();
        deleteCookie(Appsumo.licenseKey);
      } else {
        setIsSubscriptionStarted(false);
        addErrorNotification({
          message: resp.message,
          autoDismiss: 10,
        });
        deleteCookie(Appsumo.licenseKey);
        signOut();
      }
    };

    if (
      (user?.profile.firstName && user.profile.lastName) ||
      user?.profile.name
    ) {
      call();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    appsumoLicenseKey,
    createCustomerAndSubscriptionByAppsumo,
    user?.profile.firstName,
    user?.profile.lastName,
    user?.profile.name,
    isUserAnonymous,
  ]);

  if (isSubscriptionStarted) {
    return (
      <PageLoader
        message={t("common:subscription.loading")}
        data-testid="subscription-loader"
      />
    );
  }

  return null;
};
